import React from "react";
import "./styles.css";
import { config } from "../../../constants";
import { useAppSelector } from "../../../redux/store";
import GamePage from "../game-page/game-page";
import { selectPlayerMeta } from "../../../redux/selectors";

const paths = config.avatarsBig;

const Break = () => {
  const playerMeta = useAppSelector(selectPlayerMeta);

  return (
    <GamePage
      titles={["congratulations!"]}
      subHeaders={["you frantic'd a fanfic!"]}
    >
      <div className="relative flex-grow flex justify-center items-center flex-col overflow-hidden">
        <div className="break-2-bg" />
        <img
          className="z-10 max-w-[95%] max-h-[95%] object-contain break-2-animation"
          src={paths[playerMeta.sprite_id]}
          alt={paths[playerMeta.sprite_id]}
        />
      </div>
    </GamePage>
  );
};
export default Break;
